module.exports = __webpack_public_path__ + "media/flags/jp-8df20b88.svg";